import { render, staticRenderFns } from "./DataZipExportNotification.vue?vue&type=template&id=c97cb21e"
import script from "./DataZipExportNotification.vue?vue&type=script&lang=js"
export * from "./DataZipExportNotification.vue?vue&type=script&lang=js"
import style0 from "./DataZipExportNotification.vue?vue&type=style&index=0&id=c97cb21e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports